module.exports = __webpack_public_path__ + "static/img/coverCemetery.07c3156.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coverCemetery.png
// module id = LshF
// module chunks = 1